export const CURRENT_SCRIPT_BRANCH = `${process.env.REACT_APP_BRANCH_NAME && process.env.REACT_APP_BRANCH_NAME}`;
